document.querySelectorAll('.variant-packages__input').forEach((radio) => {
  radio.addEventListener('change', (event) => {
    event.stopPropagation();
    if (!radio.checked) return;
    const variantId = radio.getAttribute('data-variant-id');
    const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!form || !variantId) return;
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.disabled = false;
      idInput.value = variantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

const sellingPlanDataEl = document.querySelector('[id^="SellingPlanData-"]');

if (sellingPlanDataEl) {
  const sellingPlanData = JSON.parse(sellingPlanDataEl.textContent);
  const productForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');

  if (productForm) {
    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);

    const getSelectedVariantId = () => {
      const idInput = productForm.querySelector('input[name="id"]');
      return idInput ? idInput.value : null;
    };

    const getSellingPlanId = () => {
      const input = productForm.querySelector('input[name="selling_plan"]');
      return input ? input.value : '';
    };

    const getPrice = (variantId, sellingPlanId) => {
      const variantData = sellingPlanData[variantId];
      if (!variantData) return null;
      return (sellingPlanId && variantData.allocations[sellingPlanId] !== undefined)
        ? variantData.allocations[sellingPlanId]
        : variantData.price;
    };

    const updatePrices = () => {
      const sellingPlanId = getSellingPlanId();
      const selectedVariantId = getSelectedVariantId();

      document.querySelectorAll('.variant-packages__price[data-variant-id]').forEach((el) => {
        const price = getPrice(el.getAttribute('data-variant-id'), sellingPlanId);
        if (price !== null) el.textContent = formatMoney(price);
      });

      document.querySelectorAll('.variant-packages__price-wrap[data-variant-id]').forEach((el) => {
        const variantId = el.getAttribute('data-variant-id');
        const data = sellingPlanData[variantId];
        if (!data) return;
        const basePrice = getPrice(variantId, sellingPlanId);
        if (basePrice === null) return;
        const originalEl = el.querySelector('.variant-packages__price--original');
        const saleEl = el.querySelector('.variant-packages__price--sale');
        if (data.discount_percentage) {
          originalEl.textContent = formatMoney(basePrice);
          saleEl.textContent = formatMoney(Math.round(basePrice * (1 - data.discount_percentage / 100)));
        } else if (data.compare_at_price) {
          originalEl.textContent = formatMoney(data.compare_at_price);
          saleEl.textContent = formatMoney(basePrice);
        }
      });

      if (selectedVariantId) {
        const price = getPrice(selectedVariantId, sellingPlanId);
        if (price !== null) {
          document.querySelectorAll('[id$="--alt"] .regular-price').forEach((el) => {
            el.textContent = formatMoney(price);
          });
        }
      }
    };

    const observer = new MutationObserver(updatePrices);
    observer.observe(productForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    productForm.addEventListener('change', updatePrices);
    subscribe(PUB_SUB_EVENTS.variantChange, updatePrices);
    updatePrices();
  }
}
